import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod';

import { ResetPasswordPage } from '#modules/user/features/auth/pages/ResetPassword';

export const Route = createFileRoute('/{-$locale}/_layout/reset-password')({
  beforeLoad: async ({ context }) => {
    if (context.isAuth) {
      throw redirect({
        to: '/{-$locale}/dashboard/settings/security',
      });
    }
  },
  component: ResetPasswordPage,
  validateSearch: zodValidator(
    z.object({
      token: z.string(),
    })
  ),
  ssr: false,
});
